import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { 
  FaLinkedin, 
  FaTwitter, 
  FaFacebook, 
  FaYoutube 
} from 'react-icons/fa';

const LandingFooter = ({ onLoginClick }) => {
  const { t } = useLanguage();

  return (
    <footer className="landing-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>ArchonPM</h3>
          <p style={{ color: 'rgba(147, 197, 253, 0.95)', fontSize: '0.9rem', marginBottom: '0.75rem' }}>
            {t('footer.developedByPrefix')}{' '}
            <a href="https://www.ChrisallTech.com" style={{ color: '#93c5fd', fontWeight: 600 }} target="_blank" rel="noopener noreferrer">
              Chrisall Technologies
            </a>
          </p>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', lineHeight: '1.6' }}>
            {t('footer.description')}
          </p>
          <div className="social-links">
            <a href="#" className="social-link" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="#" className="social-link" aria-label="Twitter">
              <FaTwitter />
            </a>
            <a href="#" className="social-link" aria-label="Facebook">
              <FaFacebook />
            </a>
            <a href="#" className="social-link" aria-label="YouTube">
              <FaYoutube />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>{t('footer.sections.product.title')}</h3>
          <ul className="footer-links">
            <li><a href="#product">{t('footer.sections.product.links.features')}</a></li>
            <li><a href="#solutions">{t('footer.sections.product.links.solutions')}</a></li>
            <li><a href="#pricing">{t('footer.sections.product.links.pricing')}</a></li>
            <li><a href="#resources">{t('footer.sections.product.links.resources')}</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); if (onLoginClick) onLoginClick(); }}>{t('footer.sections.product.links.login')}</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t('footer.sections.company.title')}</h3>
          <ul className="footer-links">
            <li><a href="#about">{t('footer.sections.company.links.about')}</a></li>
            <li><a href="#careers">{t('footer.sections.company.links.careers')}</a></li>
            <li><a href="#contact">{t('footer.sections.company.links.contact')}</a></li>
            <li><a href="#blog">{t('footer.sections.company.links.blog')}</a></li>
            <li><a href="#partners">{t('footer.sections.company.links.partners')}</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t('footer.sections.support.title')}</h3>
          <ul className="footer-links">
            <li><a href="#help">{t('footer.sections.support.links.help')}</a></li>
            <li><a href="#documentation">{t('footer.sections.support.links.documentation')}</a></li>
            <li><a href="#api">{t('footer.sections.support.links.api')}</a></li>
            <li><a href="#community">{t('footer.sections.support.links.community')}</a></li>
            <li><a href="#status">{t('footer.sections.support.links.status')}</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>{t('footer.sections.legal.title')}</h3>
          <ul className="footer-links">
            <li><a href="#privacy">{t('footer.sections.legal.links.privacy')}</a></li>
            <li><a href="#terms">{t('footer.sections.legal.links.terms')}</a></li>
            <li><a href="#security">{t('footer.sections.legal.links.security')}</a></li>
            <li><a href="#compliance">{t('footer.sections.legal.links.compliance')}</a></li>
            <li><a href="#cookies">{t('footer.sections.legal.links.cookies')}</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>{t('footer.copyright')}</p>
        <p style={{ marginTop: '0.5rem', fontSize: '0.9rem' }}>
          {t('footer.tagline')}
        </p>
      </div>
    </footer>
  );
};

export default LandingFooter;
